<template>
  <div>
    <div v-for="i in users" :key="i"><divBodyOutLine :item="i" /><br /></div>
  </div>
</template>

<script>
import divBodyOutLine from "./../components/BodyOutLine/divBodyOutLine.vue";
export default {
  components: { divBodyOutLine },
  data() {
    return {
      timeout: null,
      users: [
        {
          id: "บด 1",
          key: "1",
          name: "Leanne Graham",
          username: "Bret",
          email: "Sincere@april.biz",
          website: "hildegard.org",
          phone: "022222222",
          machine_name: "เครื่องบดอาหาร บด 1",
          mac: "211604",
          model: "BUHLER",
          series: "AHZC66150",
        },
        {
          id: "บด 2",
          key: "2",
          name: "Ervin Howell",
          username: "Antonette",
          email: "Shanna@melissa.tv",
          website: "anastasia.net",
          phone: "022222222",
          machine_name: "เครื่องบดอาหาร บด 2",
          mac: "211604",
          model: "BUHLER",
          series: "AHZC66150",
        },
        {
          id: "บด 3",
          key: "3",
          name: "Clementine Bauch",
          username: "Samantha",
          email: "Nathan@yesenia.net",
          website: "ramiro.info",
          phone: "022222222",
          machine_name: "เครื่องบดอาหาร บด 3",
          mac: "211604",
          model: "BUHLER",
          series: "AHZC66150",
        },
        {
          id: "บด 4",
          key: "4",
          name: "Patricia Lebsack",
          username: "Karianne",
          email: "Julianne.OConner@kory.org",
          website: "kale.biz",
          phone: "022222222",
          machine_name: "เครื่องบดอาหาร บด 4",
          mac: "211604",
          model: "BUHLER",
          series: "AHZC66150",
        },
        {
          id: "บด 5",
          key: "5",
          name: "Chelsey Dietrich",
          username: "Kamren",
          email: "Lucio_Hettinger@annie.ca",
          website: "demarco.info",
          phone: "022222222",
          machine_name: "เครื่องบดอาหาร บด 5",
          mac: "211604",
          model: "BUHLER",
          series: "AHZC66150",
        },
      ],
    };
  },
  mounted() {
    console.log("push /EngineAssemblyLine");
    this.timeout = setTimeout(() => {
      // console.log('push /EngineAssemblyLine');
      this.$router.push({ path: "/EngineAssemblyLine" });
    }, 1000 * 10);
  },
  beforeDestroy() {
    clearTimeout(this.timeout);
  },
};
</script>

<style>
</style>